// CONSTANTS are all caps.
const NS = 'CategoryCarousel';
const CLS = 'categoryCarousel';
const BLK = '.' + CLS + '-';
const SLIDE_TO_SHOW = 4;
const CLS_IS_INITED = 'is-initialized';

import * as utils from '../../../../global/js/utils';

export class CategoryCarousel {

	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$parent = this.$el.parent();
		this.$slider = this.$el.find(`.${CLS}-slider`);
		this.$sliderWrap = this.$el.find(`.${CLS}-sliderWrap`);
		this.$btnNext = this.$el.find(`.${CLS}-btnNext`);
		this.$btnPrev = this.$el.find(`.${CLS}-btnPrev`);

		this.slidesToShow = this.$el.data('slidesToShow');
		if (this.slidesToShow && !isNaN(this.slidesToShow)) {
			this.slidesToShow = parseInt(this.slidesToShow);
		}else {
			// if the value set in the data-slides-to-show attribute
			switch (this.slidesToShow) {
				case 'displaymode-full': 
					this.slidesToShow = 4;
				break;
				case 'displaymode-half': 
					this.slidesToShow = 3;
				break;
				case 'displaymode-one-third': 
					this.slidesToShow = 2;
				break;
				case 'displaymode-two-thirds': 
					this.slidesToShow = 3;
				break;
				case 'displaymode-one-quarter': 
					this.slidesToShow = 2;
				break;
				case 'displaymode-three-quarters': 
					this.slidesToShow = 3;
				break;
			}
		}

		// if the value set in the parent
		if (this.$parent.hasClass('displaymode-full')) {
			this.slidesToShow = 4;
		} else if (this.$parent.hasClass('displaymode-half')){
			this.slidesToShow = 3;
		} else if (this.$parent.hasClass('displaymode-one-third')){
			this.slidesToShow = 2;
		} else if (this.$parent.hasClass('displaymode-two-thirds')){
			this.slidesToShow = 3;
		} else if (this.$parent.hasClass('displaymode-one-quarter')){
			this.slidesToShow = 2;
		} else if (this.$parent.hasClass('displaymode-three-quarters')){
			this.slidesToShow = 3;
		}
		
		this.initCategoryCarousel();
	}

	initCategoryCarousel() {		
		// from mobile to desktop
		let slidesToShow = this.slidesToShow || SLIDE_TO_SHOW;

		const swiper = new Swiper(this.$sliderWrap[0], {
			init: false,
			slidesPerView: 1,
			spaceBetween: 24,
			freeMode: true,
			mousewheel: true,
			navigation: {
				nextEl: this.$btnNext[0],
				prevEl: this.$btnPrev[0],
			},
			breakpoints: {
				[utils.BREAKPOINT.XS]: {
					slidesPerView: 2,
				},
				[utils.BREAKPOINT.SM]: {
					slidesPerView: 2,
				},
				[utils.BREAKPOINT.MD]: {
					slidesPerView: slidesToShow > 2 ? 3 : 2,
				},
				[utils.BREAKPOINT.LG]: {
					slidesPerView: slidesToShow,
				}
			}
		});

		swiper.on('init', () => {
			this.$el.addClass(CLS_IS_INITED);
		});

		swiper.init();
	}

	//Add more functions like on above here

}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/blocks/categoryCarousel/js/categoryCarousel.js